// ** Icons Import
import {
    Bookmark, Circle, TrendingUp, Settings, DollarSign, Type, User, UserCheck, Users, Edit
} from "react-feather";
import Member from "../Icon/Member";
import Payment from "../Icon/Payment";
import DeliveryNotes from "../Icon/DeliveryNotes";
import Order from "../Icon/Order";
import SalesOrder from "../Icon/SalesOrder";
import Stock from "../Icon/Stock";
import Tax from "../Icon/Tax";
import Supplier from "../Icon/Supplier";

export default [
    {
        id: "Entry",
        title: "Entry",
        icon: <Edit size={24} />,

        children: [
         
        ],
    },
];
